import React, { Component } from "react";
import { toEnglishNumber } from "../../classes/utils";

import "./Filter.css";

class Filter extends Component {
    constructor(props) {
        super(props);
        this.formRef = React.createRef();
        this.onFilterChange = this.onFilterChange.bind(this);
    }
    state = {};

    onFilterChange() {
        if (!this.props.onFilterChange) {
            console.error(
                "onFilterChange function not passed to Filter Component."
            );
            return;
        }

        let formdata = Object.fromEntries(new FormData(this.formRef.current));
        let keys = Object.keys(formdata);

        keys.forEach((key) => {
            formdata[key] === "on" && (formdata[key] = true);
        });

        formdata.search = toEnglishNumber(formdata.search);
        console.log(formdata.search);

        this.props.onFilterChange(formdata);
    }

    render() {
        let { filters,defaultSearch } = this.props;
        return (
            <div className="FilterComponentContainer">
                <form id="form" ref={this.formRef}></form>
                <div className="searchBox">
                    <input
                        type="text"
                        placeholder="عبارت جستوجو را اینجا بنویسید."
                        form="form"
                        name="search"
                        defaultValue={defaultSearch}
                    />
                </div>
                {filters && filters.length > 0 && (
                    <div className="filtersContainer">
                        {filters.map((f) => {
                            return (
                                <div className="filter" key={f.label}>
                                    <label
                                        className="label text info"
                                        htmlFor={f.label + f.value}
                                    >
                                        {f.label}
                                    </label>
                                    <input
                                        form="form"
                                        type="checkbox"
                                        name={f.value}
                                        id={f.label + f.value}
                                        defaultChecked={f.default}
                                    />
                                </div>
                            );
                        })}
                    </div>
                )}
                <button onClick={this.onFilterChange} className="btn confirm">
                    جستجو
                </button>
            </div>
        );
    }
}

export default Filter;
